import styled from 'styled-components';
import { H1, P } from '@btc-snxt/ui';

export const StyledSystemSettings = styled.div`
  ${H1} {
    display: flex;
    justify-content: center;
  }
`;

export const SelectLanguageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SelectLanguageLabel = styled(P)`
  margin: 0;
`;
